var $15b25ab20f3945b2$exports = {};
$15b25ab20f3945b2$exports = {
  "Empty": `Pr\xe1zdn\xe9`
};
export { $15b25ab20f3945b2$exports as default };